export class MemCacheService {
    db: dbCache[] = []

    set(key: any, object: any, clearKey: any) {
        key = this.#simpleHash(key)
        clearKey = this.#simpleHash(clearKey)
        const foundIndex = this.db.findIndex((el) => el.key === key)
        if (foundIndex > 0) this.db.splice(foundIndex, 1)
        this.db.push({
            key: key,
            clearKey: clearKey,
            createdAt: new Date(),
            value: JSON.stringify(object),
        })
    }

    get(key: string, cacheAgeLimitInSeconds: number) {
        // todo: use try-catch due concurrency
        if (!cacheAgeLimitInSeconds) return null
        const foundIndex = this.db.findIndex((el) => el.key === this.#simpleHash(key))
        if (foundIndex < 0) return null
        const diffSeconds = (new Date().getTime() - this.db[foundIndex]?.createdAt.getTime()) / 1000
        if (cacheAgeLimitInSeconds < diffSeconds) return null
        return JSON.parse(this.db[foundIndex]?.value)
    }

    clear(clearKey: any) {
        clearKey = this.#simpleHash(clearKey)
        for (let index = this.db.length - 1; index >= 0; index--) {
            if (this.db[index].clearKey === clearKey) this.db.splice(index, 1)
        }
        //console.log('cleared', this.db)
    }

    #simpleHash(obj: any) {
        const str = JSON.stringify(obj)
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash = (hash << 5) - hash + str.charCodeAt(i)
            hash &= hash // Convert to 32bit integer
        }
        return (hash >>> 0).toString(36)
    }
}

interface dbCache {
    createdAt: Date
    key: string
    clearKey: string
    value: any
}
